import { OzContent, OzGrid, OzGridRow, OzGridCell, GRID_CELL_SIZE, OzSkeletonBox, SKELETON_BOX_SIZE } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import styles from './SkeletonLoading.styles.css';

export function SkeletonLoading (): ReactElement {
    return (
        <div className="md:relative">
            <div className={`aspect-video ${styles.heroImageContainer}`}>
                <OzSkeletonBox className={styles.image} />
            </div>
            <div className={`py-3 md:py-0 md:absolute md:left-0 md:right-0 md:transform md:-translate-y-1/2 ${styles.content}`}>
                <OzContent>
                    <OzGrid>
                        <OzGridRow>
                            <OzGridCell smSize={GRID_CELL_SIZE.COLUMN_4} mdSize={GRID_CELL_SIZE.COLUMN_7} lgSize={GRID_CELL_SIZE.COLUMN_10}>
                                <OzSkeletonBox className={`mb-0 ${styles.headline1}`} />
                            </OzGridCell>
                        </OzGridRow>
                        <OzGridRow>
                            <OzGridCell smSize={GRID_CELL_SIZE.COLUMN_3} mdSize={GRID_CELL_SIZE.COLUMN_5} lgSize={GRID_CELL_SIZE.COLUMN_8}>
                                <OzSkeletonBox className={`md:mt-2 md:mb-0 ${styles.headline2}`} />
                            </OzGridCell>
                        </OzGridRow>
                        <OzGridRow>
                            <OzGridCell smSize={GRID_CELL_SIZE.COLUMN_4} mdSize={GRID_CELL_SIZE.COLUMN_6} lgSize={GRID_CELL_SIZE.COLUMN_9}>
                                <OzSkeletonBox className={`mt-3 md:mt-4 lg:mt-7 mb-0 ${styles.subtitle1}`} />
                            </OzGridCell>
                        </OzGridRow>
                        <OzGridRow>
                            <OzGridCell smSize={GRID_CELL_SIZE.COLUMN_3} mdSize={GRID_CELL_SIZE.COLUMN_4} lgSize={GRID_CELL_SIZE.COLUMN_7}>
                                <OzSkeletonBox className={`mt-1 mb-0 ${styles.subtitle2}`} />
                            </OzGridCell>
                        </OzGridRow>
                        <OzGridRow>
                            <OzGridCell smSize={GRID_CELL_SIZE.COLUMN_4} mdSize={GRID_CELL_SIZE.COLUMN_3}>
                                <OzSkeletonBox className={`mb-0 md:mt-4 md:mt-6 lg:mt-7 ${styles.link}`} size={SKELETON_BOX_SIZE.SIZE_7} />
                            </OzGridCell>
                        </OzGridRow>
                    </OzGrid>
                </OzContent>
            </div>
        </div>
    );
}
